(() => {
  const desktop = window.matchMedia('(min-width: 720px) and (hover: hover) and (pointer: fine)');
  let active = null;
  let closeTimer;
  const flyout = () => document.getElementById('b4a-black-friday-card-flyout');
  const close = () => {
    clearTimeout(closeTimer);
    if (active) active.setAttribute('aria-expanded', 'false');
    active = null;
    const bubble = flyout();
    if (bubble) bubble.hidden = true;
  };
  const scheduleClose = () => {
    clearTimeout(closeTimer);
    closeTimer = setTimeout(() => {
      const bubble = flyout();
      if (bubble?.contains(document.activeElement) || active === document.activeElement) return;
      close();
    }, 180);
  };
  const open = (stamp) => {
    if (!desktop.matches) return;
    const bubble = flyout();
    if (!bubble) return;
    clearTimeout(closeTimer);
    if (active && active !== stamp) active.setAttribute('aria-expanded', 'false');
    active = stamp;
    stamp.setAttribute('aria-expanded', 'true');
    bubble.hidden = false;
    const anchor = stamp.getBoundingClientRect();
    const rect = bubble.getBoundingClientRect();
    const left = Math.max(12, Math.min(anchor.right - rect.width, window.innerWidth - rect.width - 12));
    let top = anchor.bottom + 10;
    if (top + rect.height > window.innerHeight - 12 && anchor.top - rect.height - 10 >= 12) {
      top = anchor.top - rect.height - 10;
    }
    top = Math.max(12, Math.min(top, window.innerHeight - rect.height - 12));
    bubble.style.left = `${left}px`;
    bubble.style.top = `${top}px`;
  };
  if (!customElements.get('b4a-black-friday-stamp')) {
    customElements.define('b4a-black-friday-stamp', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const update = () => {
          if (desktop.matches) {
            this.tabIndex = 0;
            this.setAttribute('role', 'button');
            this.setAttribute('aria-expanded', 'false');
            this.setAttribute('aria-controls', 'b4a-black-friday-card-flyout');
          } else {
            ['tabindex', 'role', 'aria-expanded', 'aria-controls'].forEach(name => this.removeAttribute(name));
          }
        };
        update();
        desktop.addEventListener('change', update, options);
        this.addEventListener('pointerenter', (event) => {
          if (event.pointerType !== 'touch') open(this);
        }, options);
        this.addEventListener('pointerleave', () => {
          if (active === this) scheduleClose();
        }, options);
        this.addEventListener('focus', () => open(this), options);
        this.addEventListener('blur', (event) => {
          if (!flyout()?.contains(event.relatedTarget)) scheduleClose();
        }, options);
        this.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          if (desktop.matches) open(this);
        }, options);
        this.addEventListener('keydown', (event) => {
          if (!desktop.matches) return;
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            open(this);
          }
          if (event.key === 'ArrowDown' || event.key === 'Tab' && active === this && !event.shiftKey) {
            const link = flyout()?.querySelector('a');
            if (link) {
              event.preventDefault();
              open(this);
              link.focus();
            }
          }
        }, options);
      }
      disconnectedCallback() {
        this.controller?.abort();
        if (active === this) close();
      }
    });
  }
  const initialize = () => {
    const bubble = flyout();
    if (!bubble || bubble.dataset.initialized) return;
    bubble.dataset.initialized = 'true';
    bubble.addEventListener('pointerenter', () => clearTimeout(closeTimer));
    bubble.addEventListener('pointerleave', scheduleClose);
    bubble.addEventListener('focusout', (event) => {
      if (!bubble.contains(event.relatedTarget) && event.relatedTarget !== active) close();
    });
  };
  initialize();
  document.addEventListener('DOMContentLoaded', initialize, { once: true });
  desktop.addEventListener('change', close);
  document.addEventListener('pointerdown', (event) => {
    if (!flyout()?.contains(event.target) && !event.target.closest('b4a-black-friday-stamp')) close();
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && active) {
      const trigger = active;
      const returnFocus = flyout()?.contains(document.activeElement);
      close();
      if (returnFocus) {
        trigger.focus({ preventScroll: true });
        close();
      }
    }
  });
  window.addEventListener('resize', close);
  window.addEventListener('scroll', close, { passive: true, capture: true });
})();
